<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="12">
          <a-col :md="6" :sm="8">
            <a-form-item :label="$t(I18N_KEY.ORDER + 'queryDate')">
              <a-date-picker v-model="queryParam.queryDate" format="YYYY-MM-DD" style="width: 100%;" />
            </a-form-item>
          </a-col>

          <a-col :md="6" :sm="12">
            <a-form-item :label="$t(I18N_KEY.ORDER + 'custType')">
              <a-select v-model="queryParam.custType" style="width: 80%">
                <a-select-option value="">全部</a-select-option>
                <a-select-option value="1">新户</a-select-option>
                <a-select-option value="2">老户</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :md="6" :sm="8">
            <a-form-item :label="$t('platformCollection.collection_stage')">
              <a-select v-model="queryParam.normalConfigId" style="width: 190px" allowClear>
                <a-select-option v-for="item in normalConfigList" :key="item.id" :value="item.id">
                  {{ item.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>

        <a-row :gutter="12">
          <a-col :span="6">
            <!-- 查询加载状态 -->
            <a-button type="primary" @click="searchQuery" icon="search" :loading="loading">
              {{ $t('search') }}
            </a-button>
            <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">
              {{ $t('reset') }}
            </a-button>
          </a-col>
        </a-row>
      </a-form>

      <!-- 图表卡片 -->
      <a-card title="还款率分时统计" size="small" style="margin-top:16px;">
        <div ref="chart" class="chart-box"></div>
      </a-card>
    </div>
  </a-card>
</template>

<script>
import { getAllNormalConfig } from '@/webpublicapi/normalConfig'
import { getApplistExcludingSubApp, queryRepaymentRateLineChart } from '@/webpublicapi/order'
import moment from 'moment'

export default {
  name: 'RepaymentRateLineChart',
  data() {
    return {
      I18N_KEY: {
        ORDER: 'order.',
        CUSTOMER: 'customer.',
        REPAYREPORT: 'repayReport.',
      },
      queryParam: {
        queryDate: '',
        custType: '',
        normalConfigId: null,
        lendingTime: undefined
      },
      normalConfigList: [],
      mainAppList: [],
      myChart: null,
      loading: false,
    }
  },
  created() {
    this.loadAppList()
    this.loadNormalConfig()
  },
  mounted() {
    this.$nextTick(() => {
      // 延迟初始化 → 解决页面刚进来图表显示不全！
      setTimeout(() => {
        this.initChart()
        this.loadData()
        this.handleResize()
      }, 100)

      window.addEventListener('resize', this.handleResize)
    })
  },
  beforeDestroy() {
    if (this.myChart) {
      this.myChart.dispose()
      this.myChart = null
    }
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    // 自适应窗口
    handleResize() {
      if (this.myChart) {
        this.myChart.resize()
      }
    },
    loadAppList() {
      getApplistExcludingSubApp().then(res => {
        const list = res.data || []
        this.mainAppList = list.filter(item => item.appssid)
      })
    },
    loadNormalConfig() {
      getAllNormalConfig().then(res => {
        this.normalConfigList = [
          { name: '全部', id: '', value: '' }
        ].concat(res.data || [])
      })
    },
    initChart() {
      const dom = this.$refs.chart
      if (!dom) return
      if (this.myChart) this.myChart.dispose()
      this.myChart = this.$echarts.init(dom)
      this.renderChart([], [], [])
      this.handleResize()
    },
    // 图表渲染
    renderChart(todayData, yesterdayData, avgData) {
      if (!this.myChart) return

      const xHourData = [
        '0时','1时','2时','3时','4时','5时','6时','7时','8时','9时','10时','11时',
        '12时','13时','14时','15时','16时','17时','18时','19时','20时','21时','22时','23时'
      ]
      const option = {
        legend: { data: ['查询时间(默认为今日)', '查询时间前日', '平均值'], top: 0 },
        tooltip: { trigger: 'axis' },
        grid: { left: '3%', right: '4%', bottom: '3%', containLabel: true },
        xAxis: { type: 'category', data: xHourData, axisLabel: { interval: 0 } },
        yAxis: { type: 'value', name: '还款率(%)', min: 0, axisLabel: { formatter: '{value}' } },
        series: [
          { name: '查询时间(默认为今日)', type: 'line', data: todayData, itemStyle: { color: '#00B42A' }, lineStyle: { color: '#00B42A' }, smooth: true },
          { name: '查询时间前日', type: 'line', data: yesterdayData, itemStyle: { color: '#FFAA00' }, lineStyle: { color: '#FFAA00' }, smooth: true },
          { name: '平均值', type: 'line', data: avgData, itemStyle: { color: '#F53F3E' }, lineStyle: { color: '#F53F3E' }, smooth: true },
        ]
      }

      this.myChart.setOption(option, true)
      this.handleResize() // 每次渲染都强制自适应
    },
    searchQuery() {
      this.loadData()
    },
    loadData() {
      const p = this.getQueryParams()
      this.loading = true

      queryRepaymentRateLineChart(p)
        .then(res => {
          if (res.code === 1000) {
            const data = res.data || {}
            this.renderChart(data.todayData || [], data.yesterdayData || [], data.avgData || [])
          } else {
            this.$message.error(res.msg)
          }
        })
        .catch(e => {
          this.$message.error(e.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    getQueryParams() {
      const { queryDate } = this.queryParam
      return {
        ...this.queryParam,
        startDate: queryDate ? moment(queryDate).format('YYYY-MM-DD') : null
      }
    },
    searchReset() {
      this.queryParam = {
        queryDate: '',
        custType: '',
        normalConfigId: null
      }
      this.loadData()
    }
  }
}
</script>

<style scoped>
.chart-box {
  width: 100%;
  height: 420px;
}
</style>